import { render } from "./OpportunityDetail.vue?vue&type=template&id=2d2f49bc&scoped=true"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js"

import "./OpportunityDetail.vue?vue&type=style&index=0&id=2d2f49bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d2f49bc"

export default script